import React, { FC, useEffect, useState } from "react";
// import Checkbox from "shared/Checkbox/Checkbox";
// import CommonLayout from "./CommonLayout";
// import NcInputNumber from "components/NcInputNumber/NcInputNumber";
// import FormItem from "./FormItem";
// import Input from "shared/Input/Input";

import { AuthorType, ListingDataType ,FactsFeaturesDataType} from "data/types";
import { useLocation } from 'react-router-dom';
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { Link, useNavigate } from 'react-router-dom';
import ReactS3Client from 'react-aws-s3-typescript';
import { s3Config } from '../../utils/s3Config';

export interface PageAddListing4Props { }





const PageAddListing4: FC<PageAddListing4Props> = () => {

  const location = useLocation();
  const propertyInfo = location.state;
  const agent = propertyInfo.agent as AuthorType;
  const property = propertyInfo.property as ListingDataType;
  const [coverImage, setCoverImage] = useState('');
  // const factsF = propertyInfo.property as ListingDataType;
const navigate = useNavigate();

useEffect(() => {
  // console.log(propertyInfo);
 // console.log(property);
  //  console.log(agent);
  checkValues();
}, []);

const checkValues = () =>{

  setCoverImage(property.featuredImage || '');

}

const toNextStep = () => {
 // property.featuredImage = "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/69a38e.jpg";
 property.featuredImage = coverImage;
  property.galleryImgs = [
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/6b44f6.jpg",
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/cc6422.jpg",
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/cc329b.jpg",
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/566fa3.jpg",
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/e837a8.jpg",
    "https://vr-thumbs.vacationrenter.com/960/agoda/700245933/40290e.jpg"
];

const propertyInfo = {
  property,
  agent,
};
navigate('/add-listing-7', { state: propertyInfo });

}

const handleCoverImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files && event.target.files[0];
  const s3 = new ReactS3Client({
      ...s3Config,
      dirName: 'profiles'
  });


  if (file) {
      try {
          // const res = await s3.uploadFile(file, filename);
          const res = await s3.uploadFile(file);
          console.log(res);
          if (agent) {
            setCoverImage(res.location);
             // updateAgentAvatar(res.location);
          }
          // updateAgentData();

      } catch (exception) {
          console.log(exception);
      }
  }
};

const toPrevtStep = () => {
  const propertyInfo = {
    property,
    agent,
  };

navigate('/add-listing-2', { state: propertyInfo });


}
  return (
    // <CommonLayout
    //   index="03"
    //   backtHref="/add-listing-2"
    //   nextHref="/add-listing-7"
    // >
    //   <>
    <div
      className={`nc-PageAddListing2 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddListing2"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">3</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / 5
          </span>
        </div>
        <div>
          <h2 className="text-2xl font-semibold">Property Images</h2>

        </div> 
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="listingSection__wrap ">
        <div className="space-y-8">
           {/* ********old design******* */}
          {/*<div>
            <div className="mb-8">
                <h2 className="text-2xl font-semibold" >
                Interior Details
              </h2>
            </div>
            <div className="mb-2">
              <label className="text-lg font-semibold " htmlFor="">
                Bedrooms and bathrooms
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            </div>
            <div className="space-y-4">
              <NcInputNumber
                label="Bedrooms"
                desc=""
                defaultValue={0} />

              <NcInputNumber
                label="Bathrooms"
                desc=""
                defaultValue={0} />

              <NcInputNumber
                label="Full bathrooms"
                desc=""
                defaultValue={0} />

              <NcInputNumber
                label="1/2 bathrooms"
                desc=""
                defaultValue={0} />

            </div>
            <div className="my-8">
              <label className="text-lg font-semibold " htmlFor="">
                Interior Features
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            </div>


            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <Checkbox label="Elevator" name="Elevator" />
              <Checkbox label="Wired for Sound" name="Wired for Sound" />
              <Checkbox label="Open Floorplan" name="Open Floorplan" />
              <Checkbox label="Exercise Room" name="Exercise Room" />
              <Checkbox label="Laundry Room" name="Laundry Room" />


            </div>
          </div>

          <div>
            <label className="text-lg font-semibold" htmlFor="">
              Basements
            </label>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

              <Checkbox label="Heated" name="Heated" />
              <Checkbox label="Garage Access" name="Garage Access" />
              <Checkbox label="Storage Space" name="Storage Space" />

            </div>
          </div>

          <div>
            <label className="text-lg font-semibold" htmlFor="">
              Heating
            </label>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <Checkbox label="Forced Air" name="Forced Air" />
              <Checkbox label="Radiator" name="Radiator" />
              <Checkbox label="Oil" name="Oil" />

            </div>
          </div>
          <div>
            <label className="text-lg font-semibold" htmlFor="">
              Cooling
            </label>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <Checkbox label="Central Air" name="Central Air" />
            </div>
          </div>
          <div>
            <label className="text-lg font-semibold" htmlFor="">
              Appliances
            </label>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <Checkbox label="Electric Range" name="Electric Range" />
              <Checkbox label="Wall Oven" name="Wall Oven" />
              <Checkbox label="Microwave" name="Microwave" />
              <Checkbox label="Range Hood" name="Range Hood" />
              <Checkbox label="Refrigerator" name="Refrigerator" />
              <Checkbox label="Freezer" name="Freezer" />
              <Checkbox label="Dishwasher" name="Dishwasher" />
              <Checkbox label="Disposal" name="Disposal" />
              <Checkbox label="Washer" name="Washer" />
              <Checkbox label="Dryer" name="Dryer" />
              <Checkbox label="Wine Cooler" name="Wine Cooler" />
            </div>
          </div>
          <div>
            <label className="text-lg font-semibold" htmlFor="">
              Laundry Features
            </label>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
              <Checkbox label="Private laundry room in unit" name="Private laundry room in unit" />
              <Checkbox label="Main Level" name="Main Level" />
              <Checkbox label="Laundry Room" name="Laundry Room" />

            </div>
          </div>
          <div>
            <label className="text-lg font-semibold " htmlFor="">
              Other interior Features
            </label>
            <div className="w-14 mb-[20px] border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="space-y-6">
              <FormItem
                label="Common walls with other units/homes?"
              >
                <Input placeholder="" />
              </FormItem>
              <FormItem
                label="Total interior livable area"
              >
                <Input placeholder="" />
              </FormItem>
              <FormItem
                label="Finished area above ground"
              >
                <Input placeholder="" />
              </FormItem>

              <NcInputNumber
                label="Total number of fireplaces"
                desc=""
                defaultValue={0} />
            </div>
            <div className="my-8">
              <h2 className="text-2xl font-semibold" >
                Property Details
              </h2>
            </div>
            <div className="mb-2">
              <label className="text-lg font-semibold " htmlFor="">
                Parking
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            </div>
            <div className="space-y-6">
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                <Checkbox label="Unit Garage" name="Unit Garage" />
                <Checkbox label="Assigned" name="Assigned" />
                <Checkbox label="Secured" name="Secured" />

              </div>
              <NcInputNumber
                label="Total spaces"
                desc=""
                defaultValue={0} />
              <NcInputNumber
                label="Garage spaces"
                desc=""
                defaultValue={0} />

            </div>
            <div className="my-6">
              <label className="text-lg font-semibold " htmlFor="">
                Lot
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                <Checkbox label="Historic District" name="Historic District" />
                <Checkbox label="Level" name="Level" />
                <Checkbox label="Lightly Wooded" name="Lightly Wooded" />
                <Checkbox label="Fruit Trees" name="Fruit Trees" />
              </div>
            </div>
            <div className="my-6">
              <label className="text-lg font-semibold " htmlFor="">
                Accessibility
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
                <Checkbox label="Accessible Doors" name="Accessible Doors" />
                <Checkbox label="Accessible Hallway(s)" name="Accessible Hallway(s)" />

              </div>
            </div>
            <div className="my-6">
              <label className="text-lg font-semibold " htmlFor="">
                Property
              </label>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            </div>
            <div className="space-y-6">
              <NcInputNumber
                label="Levels"
                desc=""
                defaultValue={0} />
              <NcInputNumber
                label="Stories"
                desc=""
                defaultValue={0} />
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                <Checkbox label="Awning(s)" name="Awning(s)" />
                <Checkbox label="Garden" name="Garden" />
                <Checkbox label="Barbecue" name="Barbecue" />
                <Checkbox label="Lighting" name="Lighting" />
              </div>
            </div> 
          </div>  */}

 {/* ********End old design******* */}


          <div>
            <span className="text-lg font-semibold">Cover image</span>
            <div className="mt-5 ">
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label
                      htmlFor="file-upload"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>Click to upload a file</span>
                      <input
                        id="file-upload"
                        name="file-upload"
                        type="file"
                        className="sr-only"
                        onChange={handleCoverImageChange}
                      />
                    </label>
                    <p className="pl-1"></p>
                  </div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <span className="text-lg font-semibold">Interior/Exterior Images</span>
            <div className="mt-5 ">
              <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg
                    className="mx-auto h-12 w-12 text-neutral-400"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 48 48"
                    aria-hidden="true"
                  >
                    <path
                      d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
                    <label
                      htmlFor="file-upload-2"
                      className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                    >
                      <span>click to upload a file</span>
                      <input
                        id="file-upload-2"
                        name="file-upload-2"
                        type="file"
                        className="sr-only"
                      />
                    </label>
                    <p className="pl-1"></p>
                  </div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>
            </div>
          </div>
          </div>

          </div>
          <div className="flex justify-end space-x-5">
          <ButtonSecondary onClick={toPrevtStep}>Go back</ButtonSecondary>
          <ButtonPrimary onClick={toNextStep}> {"Continue"} </ButtonPrimary>
        </div>
        </div>
        </div>
  );
};

export default PageAddListing4;
